module.exports = __webpack_public_path__ + "static/media/nike-land-of-new-football-new-football-news-3.3a4a5704.mp4";